import { Component, Input } from '@angular/core';
import { HrBaseElementComponent } from '../hr-base-element/hr-base-element.component';

@Component({
    selector: 'hr-form-inputNumber',
    templateUrl: './hr-form-inputNumber.component.html',
})
export class HrFormInputNumberComponent extends HrBaseElementComponent {
    @Input() min: number = 0;
    @Input() max: number;
}
